module.exports = __webpack_public_path__ + "FSAlbert Light Italic.17c7414475512cc024a6.ttf";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fsAlbert/FSAlbert Light Italic.ttf
// module id = ../../../../../src/assets/fonts/fsAlbert/FSAlbert Light Italic.ttf
// module chunks = main